import { render, staticRenderFns } from "./Shows.vue?vue&type=template&id=9f333a20"
import script from "./Shows.vue?vue&type=script&lang=js"
export * from "./Shows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports